export default function checkOverlapOfRange(a, b) {
    return ((a.end - b.start) >= 0 && (b.end - a.start) >= 0)
}